import React, { FC } from 'react';
import classnames from 'classnames';
import { StackProps } from './props';
import './styles.scss';

export const Stack: FC<StackProps> = ({ className, currentStackKey, stack }) => {
  return (
    <div className={classnames('stack', className)}>
      {stack?.map(({ key, className, content }, index) => {
        const isCurrentView = (!currentStackKey && index === 0) || currentStackKey === key;
        const hiddenClassName = className && !isCurrentView ? `${className}--hidden` : undefined;

        return (
          <div
            className={classnames('stack__view', className, hiddenClassName, {
              'stack__view--hidden': !isCurrentView,
            })}
            key={key}
          >
            {content}
          </div>
        );
      })}
    </div>
  );
};
